import {
  incidentStatusConfig,
  openIncidentStatuses,
  resolvedIncidentStatuses,
  type IncidentSeverity,
} from '~/app/dashboard/mock-data';

export type TimeFilterKey = '24h' | '48h' | '30d' | 'all';

export type ChartFilterKey = '1m' | '1y' | 'all';

export const severityOrder: Record<IncidentSeverity, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
};

export const severityConfig: Record<
  IncidentSeverity,
  { color: string; label: string }
> = {
  critical: { color: '#e23b4a', label: 'Critical' },
  high: { color: '#ec7e00', label: 'High' },
  medium: { color: '#faad14', label: 'Medium' },
  low: { color: '#00a87e', label: 'Low' },
};

export const dashboardTimeFilters: Array<{
  value: TimeFilterKey;
  label: string;
  hours: number | null;
}> = [
  { value: '24h', label: 'Less than 24h', hours: 24 },
  { value: '48h', label: 'Less than 48h', hours: 48 },
  { value: '30d', label: 'Last month', hours: 24 * 30 },
  { value: 'all', label: 'All', hours: null },
];

export const chartFilters: Array<{
  value: ChartFilterKey;
  label: string;
}> = [
  { value: '1m', label: 'last month' },
  { value: '1y', label: 'last year' },
  { value: 'all', label: 'all' },
];

export const groupedStatusDefinitions = [
  {
    key: 'open',
    label: 'Open',
    color: '#e23b4a',
    statuses: [...openIncidentStatuses],
  },
  {
    key: 'resolved',
    label: 'Resolved',
    color: '#00a87e',
    statuses: [...resolvedIncidentStatuses],
  },
] as const;

export { incidentStatusConfig, openIncidentStatuses };
